import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { clearChatById } from '../../api';

interface ClearChatDialogProps {
  open: boolean;
  onClose: () => void;
  chatId: string | null;
  showSnackbar: (options: {
    message: string;
    severity: 'success' | 'error' | 'info' | 'warning';
  }) => void;
  onClearSuccess: () => void;
}

const ClearChatDialog = ({
  open,
  onClose,
  chatId,
  showSnackbar,
  onClearSuccess,
}: ClearChatDialogProps) => {
  const handleClearChat = () => {
    if (!chatId) return;
    clearChatById(chatId)
      .then((res) => {
        const n = res?.deleted ?? 0;
        showSnackbar({ message: `Удалено сообщений: ${n}`, severity: 'success' });
        onClearSuccess();
      })
      .catch(() => {
        showSnackbar({ message: `Ошибка очистки чата`, severity: 'error' });
      })
      .finally(() => {
        onClose();
      });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Очистить чат?</DialogTitle>
      <DialogContent>Вы уверены, что хотите удалить все сообщения текущего чата?</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button color="error" variant="contained" onClick={handleClearChat} disabled={!chatId}>
          Очистить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClearChatDialog;
